//import { CRMErrors } from '../constants';
import { ZENDESK_SETTINGS_BY_PLAN } from './zendeskSettingsByPlan';

class CRMProviders {
	crmProvider = 'zendesk';
	shouldShowLauncher = false;

	boot() {
		window.zESettings = ZENDESK_SETTINGS_BY_PLAN.anonymous();
		const that = this;
		const script = document.createElement('script');
		script.setAttribute('id', 'ze-snippet');
		script.setAttribute('src', `https://static.zdassets.com/ekr/snippet.js?key=129a4ebe-f72b-4424-9082-93315a070e0d`);
		script.onload = () => {
			that.zendesk('webWidget', 'hide');
			that.zendesk('webWidget', 'prefill', {
				name: {
					value: '',
					readOnly: false,
				},
				email: {
					value: '',
					readOnly: false,
				},
			});
			that.zendesk('webWidget:on', 'close', () => {
				if (!that.shouldShowLauncher) {
					that.hideLauncher();
				}
			});
		};
		document.head.appendChild(script);
	}
	isActive() {
		return !!window.Intercom;
	}

	showLauncher() {
		this.shouldShowLauncher = true;
		if (this.crmProvider === 'zendesk') {
			this.zendesk('webWidget', 'show');
		} else {
			this.intercom('update', { hide_default_launcher: false });
		}
	}

	hideLauncher() {
		this.shouldShowLauncher = false;

		if (this.crmProvider === 'zendesk') {
			this.zendesk('webWidget', 'hide');
		} else {
			this.intercom('update', { hide_default_launcher: true });
		}
	}

	show() {
		if (this.crmProvider === 'zendesk') {
			const currentShouldShowLauncher = this.shouldShowLauncher;
			this.showLauncher();
			this.shouldShowLauncher = currentShouldShowLauncher;

			this.zendesk('webWidget', 'open');
		} else {
			this.intercom('show');
		}
	}

	hide() {
		if (this.crmProvider === 'zendesk') {
			this.zendesk('webWidget', 'close');
		} else {
			this.intercom('hide');
		}
	}

	showNewMessage(message) {
		if (this.crmProvider === 'zendesk') {
			// TODO
		} else {
			this.intercom('showNewMessage', message);
		}
	}

	trackEvent(event) {
		this.intercom('trackEvent', event);
	}
	updateMe(user, account) {
		this.intercom('update', { email: user.email });
		this.zendesk('webWidget', 'identify', { email: user.email, name: user.name });
		this.updateZendesk(user, account);
	}
	updateUserCompanyData(email, company) {
		this.intercom('update', { email, company });
		this.zendesk('webWidget', 'identify', { email, ...company });
	}
	shutDown() {
		this.intercom('shutdown');
		this.zendesk('webWidget', 'logout');
		this.zendesk('webWidget', 'reset');
		this.zendesk('webWidget', 'updateSettings', ZENDESK_SETTINGS_BY_PLAN.anonymous());
	}
	setProvider(provider) {
		this.crmProvider = provider;
	}

	updateZendesk(user, account) {
		this.zendesk('webWidget', 'prefill', {
			name: {
				value: user.name,
				readOnly: true,
			},
			email: {
				value: user.email,
				readOnly: true,
			},
		});
		let settingsPlan = account.plan;
		if (settingsPlan !== 'enterprise' && settingsPlan !== 'free') {
			settingsPlan = 'paid';
		}

		const settingsByPlan = ZENDESK_SETTINGS_BY_PLAN[settingsPlan](user.name, user.email);

		this.zendesk('webWidget', 'updateSettings', settingsByPlan);
	}

	get intercom() {
		if (!window.Intercom) {
			return; //throw new Error(CRMErrors.undefinedProvider);
		}
		return window.Intercom;
	}

	get zendesk() {
		if (!window.zE) {
			return; //throw new Error(CRMErrors.undefinedProvider);
		}
		return window.zE;
	}
}

export default CRMProviders;
